/**
 * @file 产品使用场景概览
 * @author wanzhongyun
 */

import React from 'react';
import {Row} from 'antd';
import Icon from '@ant-design/icons';
import {IProductPreviewGroupItem} from '../../types';
import ProductCard from './ProductCard';

import {ReactComponent as Recycle} from './image/recycle.svg';
import PTabs from './PTabs';


interface IProductScenePreviewProps {
    group: IProductPreviewGroupItem[];
}

const ProductScenePreview: React.FC<IProductScenePreviewProps> = props => {
    const group = props.group;

    return (
        <div className="paddle-psp">
            {group.map((step, index) => (
                <div key={`${step.title}${index}`} className="paddle-psp-step">
                    <div className="paddle-psp-step-line">
                        {step.icon === 'recycle'
                        && (
                            <span className="paddle-psp-step-line-step-item-icon">
                                <Icon component={Recycle} />
                            </span>
                        )}
                        {!step.icon
                        && (
                            <span className="paddle-psp-step-line-step-item">
                                {step.iconText}
                            </span>
                        )}
                        <span className="paddle-psp-step-line-step-line" />
                    </div>
                    <div className="paddle-psp-step-inner">
                        <div className="paddle-psp-step-title">
                            {step.title}
                            {/* <span className="paddle-psp-step-text">
                                {step.text}
                            </span> */}
                        </div>
                        <div className="paddle-psp-step-product-tabs">
                            {step.tabs.length === 0 || (step.tabs.length === 1 && !step.tabs[0].title)
                                ? (step.tabs.map((tab) => (
                                    <Row
                                        key={tab.title}
                                        className="paddle-psp-step-product-list clear-both"
                                        gutter={10}
                                    >
                                        {tab.list.map((product, index, thisArr) => (
                                            <ProductCard
                                                key={`${product.title}${product.text}${product.extraText}`}
                                                {...product}
                                            />
                                        ))}
                                    </Row>
                                )))
                                : (
                                    <PTabs
                                        className="paddle-psp-step-product-tab"
                                        defaultActiveKey={step.tabs.find(tab => tab.defaultShow)?.title}
                                        tabs={step.tabs}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductScenePreview;
